"use strict";
'use es6';
/* eslint-disable react/no-multi-comp */

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _draftJs = require("draft-js");

var _draftExtend = require("draft-extend");

var _usageTracking = require("rich-text-lib/constants/usageTracking");

var _SmallToggleButton = _interopRequireDefault(require("draft-plugins/components/SmallToggleButton"));

var _constants = require("draft-plugins/lib/constants");

var _styleUtils = require("draft-plugins/utils/styleUtils");

var _usageTracker = require("../tracking/usageTracker");

var _immutable = require("immutable");

var getSelectedInlineStyles = _draftExtend.pluginUtils.getSelectedInlineStyles;
var Tracker;

var logInlineKeyboardShortcut = function logInlineKeyboardShortcut(style) {
  Tracker.track('draftFormatting', {
    action: _usageTracking.CHANGE_INLINE_STYLE,
    method: 'keyboard-shortcut',
    value: style.toLowerCase()
  });
};

var _default = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$includedStyles = _ref.includedStyles,
      includedStyles = _ref$includedStyles === void 0 ? null : _ref$includedStyles,
      _ref$allowClearStyles = _ref.allowClearStyles,
      allowClearStyles = _ref$allowClearStyles === void 0 ? true : _ref$allowClearStyles;

  if (!Tracker) {
    Tracker = (0, _usageTracker.createTracker)();
  }

  var createInlineStyleButton = function createInlineStyleButton(_ref2) {
    var name = _ref2.name,
        style = _ref2.style,
        icon = _ref2.icon;

    var tooltip = _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "draftPlugins.inlineStylesPlugin.tooltips." + name
    });

    return (0, _createReactClass.default)({
      displayName: 'InlineStyleButton',
      propTypes: {
        disabled: _propTypes.default.bool,
        editorState: _propTypes.default.object,
        onChange: _propTypes.default.func
      },
      getDefaultProps: function getDefaultProps() {
        return {
          disabled: false
        };
      },
      handleToggleStyle: function handleToggleStyle() {
        var _this$props = this.props,
            editorState = _this$props.editorState,
            onChange = _this$props.onChange;

        var editorStateWithForcedSelection = _draftJs.EditorState.forceSelection(editorState, editorState.getSelection());

        if (editorState.getSelection().isCollapsed()) {
          var currentStyles = editorState.getCurrentInlineStyle();
          editorStateWithForcedSelection = _draftJs.EditorState.setInlineStyleOverride(editorStateWithForcedSelection, currentStyles);
        }

        var editorStateWithInlineStyle = _draftJs.RichUtils.toggleInlineStyle(editorStateWithForcedSelection, style);

        onChange(editorStateWithInlineStyle);
        Tracker.track('draftFormatting', {
          action: _usageTracking.CHANGE_INLINE_STYLE,
          method: 'toolbar',
          value: style.toLowerCase()
        });
      },
      render: function render() {
        var _this$props2 = this.props,
            editorState = _this$props2.editorState,
            disabled = _this$props2.disabled;
        var isStyleActive = editorState.getCurrentInlineStyle().has(style);
        var btnClass = style ? style.toLowerCase() + "-button" : '';
        var isButtonActive = !disabled && isStyleActive;
        return _react.default.createElement(_SmallToggleButton.default, {
          active: isButtonActive,
          className: btnClass,
          disabled: disabled,
          icon: icon,
          onClick: this.handleToggleStyle,
          tooltip: tooltip
        });
      }
    });
  };

  var clearStylesTooltip = _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "draftPlugins.inlineStylesPlugin.tooltips.clear"
  });

  var ClearStylesButton = (0, _createReactClass.default)({
    displayName: "ClearStylesButton",
    propTypes: {
      editorState: _propTypes.default.object,
      onChange: _propTypes.default.func,
      defaultStyle: _propTypes.default.instanceOf(_immutable.OrderedSet)
    },
    handleClearStyles: function handleClearStyles() {
      var _this$props3 = this.props,
          editorState = _this$props3.editorState,
          onChange = _this$props3.onChange,
          defaultStyle = _this$props3.defaultStyle;
      var selection = editorState.getSelection();
      var allInlineStyles = getSelectedInlineStyles(editorState);
      var newContentState = (0, _styleUtils.removeStyles)(editorState.getCurrentContent(), selection, allInlineStyles);
      var defaultStyledContentState = (0, _styleUtils.applyStyles)(newContentState, selection, // defaultStyle can be null, use fallback here rather in destructure
      defaultStyle || (0, _immutable.OrderedSet)());

      var newEditorState = _draftJs.EditorState.push(editorState, defaultStyledContentState, 'change-inline-style');

      onChange(_draftJs.EditorState.forceSelection(newEditorState, newEditorState.getSelection()));
    },
    render: function render() {
      return _react.default.createElement(_SmallToggleButton.default, {
        active: false,
        label: "Clear formatting",
        icon: 'removeTextStyle',
        onClick: this.handleClearStyles,
        tooltip: clearStylesTooltip
      });
    }
  });
  var buttons;

  if (includedStyles) {
    var styles = _constants.INLINE_STYLES.filter(function (_ref3) {
      var style = _ref3.style;
      return includedStyles.indexOf(style) !== -1;
    });

    buttons = styles.map(createInlineStyleButton);
  } else {
    buttons = _constants.INLINE_STYLES.map(createInlineStyleButton);
  }

  if (allowClearStyles) {
    buttons.push(ClearStylesButton);
  }

  var hasStyle = function hasStyle(style) {
    return includedStyles === null || includedStyles.indexOf(style) !== -1;
  };

  var keyCommandListener = function keyCommandListener(editorState, command) {
    switch (command) {
      case 'bold':
        if (hasStyle('BOLD')) {
          logInlineKeyboardShortcut('BOLD');
          return _draftJs.RichUtils.toggleInlineStyle(editorState, 'BOLD');
        }

        return null;

      case 'italic':
        if (hasStyle('ITALIC')) {
          logInlineKeyboardShortcut('ITALIC');
          return _draftJs.RichUtils.toggleInlineStyle(editorState, 'ITALIC');
        }

        return null;

      case 'underline':
        if (hasStyle('UNDERLINE')) {
          logInlineKeyboardShortcut('UNDERLINE');
          return _draftJs.RichUtils.toggleInlineStyle(editorState, 'UNDERLINE');
        }

        return null;

      case 'backspace':
      case 'backspace-word':
      case 'backspace-to-start-of-line':
        return _draftJs.RichUtils.onBackspace(editorState);

      case 'delete':
      case 'delete-word':
      case 'delete-to-end-of-block':
        return _draftJs.RichUtils.onDelete(editorState);

      default:
        return null;
    }
  };

  return (0, _draftExtend.createPlugin)({
    buttons: buttons,
    keyCommandListener: keyCommandListener,
    displayName: 'InlineStyles'
  });
};

exports.default = _default;
module.exports = exports.default;